// extracted by mini-css-extract-plugin
export default {"loading-box":"style_loading-box__oow9e"};